export default {
  list: ({ list }) => list,
  total: ({ total }) => total,
  selected: ({ selected }) => selected,
  tableOptions: ({ tableOptions }) => tableOptions,
  customers: ({ customers }) => customers,
  invoices: ({ invoices }) => invoices,
};
